import type { ChatMessage } from '../../shared/protocol.ts';
import { $, el } from '../common/dom.ts';

const MAX_LINES = 40;

export class ChatBox {
  private readonly root = $('#chat');
  private readonly log = $('#chat-log');
  readonly input = $<HTMLInputElement>('#chat-input');

  constructor(onSend: (text: string) => void) {
    // Sur mobile, le champ de saisie est replié derrière le bouton de chat (bord droit) : il l'ouvre ou le referme.
    const button = $('#btn-chat');
    // Le bouton ne prend pas le focus : le champ ouvert ne le perd pas avant le clic, qui peut alors le refermer.
    button.addEventListener('pointerdown', (event) => event.preventDefault());
    button.addEventListener('click', () => (this.isTyping ? this.input.blur() : this.focus()));
    this.input.addEventListener('blur', () => {
      this.root.classList.remove('open');
      button.classList.remove('active');
    });
    this.input.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== 'Escape') return;
      // La touche s'arrête ici : sinon le jeu, qui ne nous voit plus écrire, rouvrirait le chat (Entrée) ou fermerait un panneau (Échap).
      event.preventDefault();
      event.stopPropagation();
      if (event.key === 'Escape') return this.input.blur();
      const text = this.input.value.trim();
      if (text) onSend(text);
      this.input.value = '';
      this.input.blur();
    });
  }

  get isTyping(): boolean {
    return document.activeElement === this.input;
  }

  focus(): void {
    this.root.classList.add('open');
    $('#btn-chat').classList.add('active');
    this.input.focus();
  }

  append({ username, text }: ChatMessage): void {
    this.log.append(el('div', {}, el('b', { textContent: `${username} ` }), text));
    while (this.log.children.length > MAX_LINES) this.log.firstElementChild?.remove();
    this.log.scrollTop = this.log.scrollHeight;
  }
}
